import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { AlloyButton, Modal } from 'cat-ecommerce-alloy';
import { useDispatch } from 'react-redux';
import { pendingQuoteStatePropType } from '../../declarations.propTypes';
import { replaceTokensInString } from '@app/utils';
import { clearError, setError } from '@app/store/exception/actions';
import { setCloseSystemFeedback } from '@app/store/account/actions';
import { useDeletePendingQuote } from '@app/hooks';
import { useBackToQuotesSearchPage } from '@app/components/pages/account/hooks';

const DeleteQuoteModal = ({
  item,
  errorDomain,
  close,
  isOpen,
  redirectToPendingQuotes = false,
  errorPath
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const title = replaceTokensInString(
    t('DELETE_QUOTE_CONF'),
    item.quoteDocumentNumber
  );
  const { goBackToQuotesSearchPage } = useBackToQuotesSearchPage();
  const { deleteQuote } = useDeletePendingQuote();
  const handleDeleteQuote = async () => {
    close();
    dispatch(setCloseSystemFeedback(false));
    try {
      dispatch(clearError(errorDomain, errorPath));
      await deleteQuote(item).then(() => {
        if (redirectToPendingQuotes) {
          goBackToQuotesSearchPage();
        }
      });
    } catch (_) {
      const errorMessage = {
        title: t('PENDING_QUOTE_DELETE_ERROR2'),
        message: replaceTokensInString(
          t('PENDING_QUOTE_DELETE_ERROR'),
          item.quoteDocumentNumber
        )
      };
      dispatch(setError(errorDomain, errorPath, errorMessage));
    }
  };
  return (
    <Modal close={close} isOpen={isOpen} title={title}>
      <div>
        <p className="u-color--DarkGray u-fs--16">
          {t('DELETE_QUOTE_CONF_TEXT')}
        </p>
        <div className="d-flex flex-md-row-reverse flex-column mt-2">
          <AlloyButton
            buttonType="primary"
            size="dynamic"
            onClick={handleDeleteQuote}
          >
            {t('DELETE_QUOTE_YES')}
          </AlloyButton>

          <AlloyButton
            size="dynamic"
            buttonType="ghost"
            onClick={close}
            className="mt-md-0 mt-2 me-md-3 me-0"
          >
            {t('MO_CancelButton')}
          </AlloyButton>
        </div>
      </div>
    </Modal>
  );
};
export default DeleteQuoteModal;
DeleteQuoteModal.propTypes = {
  item: pendingQuoteStatePropType,
  errorDomain: PropTypes.string,
  errorPath: PropTypes.string,
  close: PropTypes.func,
  isOpen: PropTypes.bool,
  redirectToPendingQuotes: PropTypes.bool
};
